.input {
    font-size: var(--mantine-font-size-sm);
    font-weight: 500;
    line-height: var(--mantine-line-height-sm);
}
